import { Alert, Box, Button, CardMedia, Snackbar, Stack, Typography } from "@mui/material"
import { useEffect } from "react"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { v4 as uuidv4 } from "uuid";
import axios from 'axios';
import { rutas } from "../../../rutas/rutas";
import { getCookie } from "../../../utils/getCookie";
import { setInformacion } from "../../../storage/slices/usuarios";

export const Crafting = () => {
     const { especiales = [], generalNft = [] } = useSelector((state) => state.userSlice);
    const {informacion}  = useSelector(state=> state.userSlice )
    const [ barajitas, setBarajita ] = useState([])
    const [ seleccion, setSeleccion ] = useState([])
    const [open2, setOpen2] = useState(false);
    const [error, setError] = useState(false);
    const dispatch = useDispatch()

    const rarezas = {
        C: 5,
        R:4,
        E:3,
        L:2
    }
    const handleClose2 = () => setOpen2(false);
    const addBarajita = (card)=>{
        const longitud = seleccion.filter(cartas=> cartas?.id === card?.id).length
        const longitudRareza = seleccion.filter(cartas=> cartas?.rareza === card?.rareza).length
      
        if(seleccion?.length > 0 ){
          
            if( card?.id[0] === seleccion[0]?.id[0] &&card?.rareza === seleccion[0]?.rareza && rarezas[seleccion[0]?.rareza] > longitudRareza && longitud < card?.cantidad)setSeleccion([...seleccion, {...card,  ideFront: uuidv4()}])

        }else{
            if( longitud < card?.cantidad)setSeleccion([...seleccion, {...card, ideFront: uuidv4()}])

        }
    }
    const ejecutarCrafting = () => {
        const longitudRareza = seleccion.filter(cartas=> cartas?.rareza === seleccion[0]?.rareza).length
        if(rarezas[seleccion[0]?.rareza] === longitudRareza){
            const tokenJWT = getCookie("token");
            const ruta =   rutas.crafting
          
            axios
              .post(
                ruta,
                { cartas: seleccion },
                { headers: { token: tokenJWT } }
              )
              .then((res) => {
                setError(false)
                setOpen2(true)
                setSeleccion([])
           
                dispatch(setInformacion({...res.data?.resultado}))
                // if (Array.isArray(res.data?.carta)) {
                //   console.log(res.data?.carta)
                //   setSobresAbierto(res.data.carta);
                //   handleOpen();
                // }
              })
              .catch((err) => {
                setError(true)
                setOpen2(true)
                console.error(err)});
        }

      };
   
    const deleteBarajita = (card)=>{
        setSeleccion(state=> state.filter(carta=>carta?.ideFront !== card?.ideFront))
    }
    useEffect(()=>{
        let total = []
        if(informacion?.especial?.length > 0){
            total = [...total, ...informacion?.especial].map(i=> ({...i, url: [...especiales,...generalNft ].find(t=> t.ide === i.ide)?.url}))
        } 
         if(informacion?.general?.length > 0){
            
            total = [...total, ...informacion?.general].map(i=> ({...i, url:  [...especiales,...generalNft ].find(t=> t.ide === i.ide)?.url}))

        }
      
        setBarajita(total)
    },[informacion])

  return (
    <>
  
    <Box sx={{ height: '100%', width: '100%', display: 'flex' }}>
        <Box sx={{height: '100%', width: '30%', background: 'rgba(0,0,0,0.3)', marginRight: 1}} >
        <Box sx={{height: '100%', width: '100%'}}>
            <Typography sx={{color: 'white',fontSize: '1.3rem', textAlign: 'center', textShadow: '2px 2px 3px gold'}}>You need {rarezas[seleccion[0]?.rareza] ? rarezas[seleccion[0]?.rareza] : 0 } {seleccion[0]?.rareza} Cards </Typography>
            <Box sx={{display:'flex', flexWrap: 'wrap', height: '80%', justifyContent: 'center'}}>
            {seleccion.map(card=><Box  sx={{position: 'relative', width: '95px'}}  key={uuidv4()} >
                <Box sx={{  position: 'absolute', color: 'white'}}>{card?.id[0] === "E"? 'E': 'G'} - {card?.cantidad}</Box>
                <CardMedia
                onClick={()=>deleteBarajita(card)}
                sx={{width: '85px', cursor: 'pointer'}}
                        component="img"
                        image={card?.url}
                        alt="Inicial"/> 
            </Box>
             )}
            </Box>
            <Button onClick={ejecutarCrafting} fullWidth color="error" variant="contained" >Crafting</Button>
        </Box>
        </Box>
        <Box sx={{background: 'rgba(0,0,0,0.3)',height: '100%', width: '80%', display:'flex', flexWrap: 'wrap', overflow: 'auto'}}>
            {barajitas.map(card=><Box  sx={{position: 'relative', width: '125px'}}  key={uuidv4()} >
                <Box sx={{  position: 'absolute', color: 'white'}}>{card?.id[0] === "E"? 'E': 'G'} - {card?.cantidad}</Box>
                <CardMedia
                onClick={()=>addBarajita(card)}

                sx={{width: '125px', cursor: 'pointer'}}
                        component="img"
                        image={card?.url}
                        alt="Inicial"/> 
            </Box>
             )}

        </Box>

    </Box>
            <Stack spacing={2} sx={{ width: "100%" }}>
            <Snackbar open={open2} autoHideDuration={6000} onClose={handleClose2}>
          {
             error ?   <Alert
                onClose={handleClose2}
                severity="error"
                variant="filled" 
                sx={{ width: "100%" }}
              >
               Insufficient Balance Error
              </Alert>
              :
              <Alert
                onClose={handleClose2}
                severity="success"
                variant="filled" 
                sx={{ width: "100%" }}
              >
                Success
              </Alert>
          }
            </Snackbar>
          </Stack>
          </>
  )
}
